module.exports = __webpack_public_path__ + "media/images/empty_cart-491217d1dc53526e7d55a32e8faf8212.png";